





















































































































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import AuthModule from '@/store/modules/Auth';
import CurrencyModule from '@/store/modules/Currency';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Statement from '@/components/Statement.vue';
import DepositWithdrawBody from '@/components/Table/DepositWithdrawBody.vue';
import Pagination from '@/components/Pagination.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Statement,
    Pagination,
    DepositWithdrawBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  StatementInstance = getModule(StatementModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  Criteria: any = {
    ...this.Period,
    role: this.AuthInstance.user.role,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    isSearch: false,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      role: this.AuthInstance.user.role,
    },
  ];

  PaginationDetail = {
    current: 1,
    amount: 10,
    size: 100,
  }

  StatementList: any = {};

  modal = false;

  dataList: any = [];

  LoginName = '';

  TableHead = DepositWithdrawData.TableHead;

  multiCurrency = [];

  statementCriteria = {
    username: '',
    role: '',
  }

  sum = {
    totalCreditDeposit: 0,
    totalCreditWithdraw: 0,
    creditBalance: 0,
    totalAutoDeposit: 0,
    totalAutoWithdraw: 0,
    autoBalance: 0,
  };

  statement: any[] = [];

  currencyRate = {};

  toggleMode = false;

  startDate = '';

  endDate = '';

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  async created() {
    this.initial();
    this.fetchStatement();
    this.statement = [];
  }

  initial() {
    this.Criteria = {
      ...this.Period,
      role: this.AuthInstance.user.role,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
    };
    this.LoginName = '';
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  async fetchStatement() {
    this.statement = [];
    const resMulticurrency = await this.CurrencyInstance.fetchCurrencyRate();
    this.currencyRate = resMulticurrency.rateCurrency;
    this.multiCurrency = resMulticurrency.currency;
    const criteria = { ...this.Criteria, ...this.Period };
    this.GeneralInstance.toggleLoading(true);
    const res = await this.StatementInstance.FetchStatement(criteria);
    this.StatementList = this.StatementInstance.dataStatement;
    this.multiCurrency.forEach(async (v: any) => {
      this.statement.push({
        data: this.StatementList.statements.filter((x: any) => x.currency === v),
        currency: v,
      });
    });
    this.statement.sort((a: any, b: any) => b.data.length - a.data.length);
    if (res.code) {
      this.checkError(res);
    } else {
      this.BreadcrumbList = [
        ...this.BreadcrumbDefault,
        ...this.StatementInstance.dataStatement.breadcrumb,
      ];
      this.calPagination({
        instance: 'StatementList',
        dataKey: 'statements',
      });
      this.summarize();
    }
    this.GeneralInstance.toggleLoading(false);
  }

  async summarize() {
    Object.keys(this.sum).forEach((key) => {
      this.sum[key] = this.StatementList.statements
        .reduce((acc, cur: any) => (acc + cur[key]), 0);
    });
  }

  openDetail(username, role) {
    this.modal = true;
    this.statementCriteria = {
      username,
      role,
    };
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchStatement();
  }

  onSubmit() {
    this.fetchStatement();
  }

  onReset() {
    this.initial();
    this.fetchStatement();
  }

  handleSearch() {
    this.Criteria.isSearch = !!this.LoginName;
    this.Criteria.username = this.LoginName ? this.LoginName : this.AuthInstance.user.username;
  }

  handleFetcDepositWithdraw(username, role, source) {
    this.beforeFetch(username, role, source);
    this.fetchStatement();
  }

  handleBreadcrumb({ username, role, source }) {
    this.beforeFetch(username, role, source);
    this.fetchStatement();
  }

  beforeFetch(username, role, source) {
    this.Criteria.username = username;
    this.Criteria.role = role;
    this.Criteria.source = source;
    this.Criteria.isSearch = false;
    this.LoginName = '';
  }

  switchFullmode() {
    if (this.toggleMode) {
      this.toggleMode = false;
    } else {
      this.toggleMode = true;
    }
  }
}
